/* ============================================================
   LOUGEZA — Theme JS (preview.html replica, Shopify-wired)
   Cart drawer + AJAX add-to-cart + variant picker + checkout
   ============================================================ */
'use strict';

(function () {
  /* ── Money formatter (uses shop currency) ── */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var c = (window.LzConfig && window.LzConfig.currency) || 'SEK';
    return amount + ' ' + c;
  }

  /* ── Toast ── */
  function showToast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ── Modals & drawers ── */
  function openMenu() {
    var n = document.getElementById('mob-nav');
    if (n) { n.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }
  function closeMenu() {
    var n = document.getElementById('mob-nav');
    if (n) { n.classList.remove('open'); document.body.style.overflow = ''; }
  }
  function openSG() {
    var o = document.getElementById('sg-overlay');
    if (o) { o.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }
  function closeSG(e) {
    var o = document.getElementById('sg-overlay');
    if (!o) return;
    if (!e || e.target === o) { o.classList.remove('open'); document.body.style.overflow = ''; }
  }
  function openCart() {
    var ov = document.getElementById('cart-ov');
    var dr = document.getElementById('cart-dr');
    if (ov) ov.classList.add('open');
    if (dr) dr.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    var ov = document.getElementById('cart-ov');
    var dr = document.getElementById('cart-dr');
    if (ov) ov.classList.remove('open');
    if (dr) dr.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── Cart rendering ── */
  function renderCart(cart) {
    var hdCount = document.getElementById('cart-count-hd');
    var badge   = document.getElementById('cart-badge');
    var empty   = document.getElementById('cart-empty-state');
    var list    = document.getElementById('cart-items-list');
    var foot    = document.getElementById('cart-foot');
    var totEl   = document.getElementById('cart-total-val');
    var n = cart.item_count || 0;

    if (hdCount) hdCount.textContent = n;
    if (badge) {
      badge.textContent = n;
      badge.style.display = n > 0 ? 'flex' : 'none';
    }

    if (n === 0) {
      if (empty) empty.style.display = 'flex';
      if (list)  list.style.display  = 'none';
      if (foot)  foot.style.display  = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (list)  list.style.display  = 'block';
    if (foot)  foot.style.display  = 'block';
    if (totEl) totEl.textContent   = formatMoney(cart.total_price);

    if (!list) return;
    list.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2') + '" alt="">'
        : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p style="font-size:11px;color:var(--muted);margin-bottom:8px">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      return (
        '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item-img">' + img + '</div>' +
          '<div style="flex:1">' +
            '<p style="font-size:13px;font-weight:500;margin-bottom:4px">' + escapeHtml(item.product_title) + '</p>' +
            variant +
            '<p style="font-size:13px">' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' +
          '<button data-remove="' + item.key + '" style="background:none;border:none;cursor:pointer;color:var(--muted);font-size:18px;padding:4px 8px;align-self:flex-start;line-height:1" aria-label="Remove">&times;</button>' +
        '</div>'
      );
    }).join('');

    list.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { removeItem(b.dataset.remove); });
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (err) { console.error('refreshCart', err); });
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (err) { console.error('removeItem', err); });
  }

  function addItem(variantId, quantity, btn) {
    var defaultLabel = btn ? btn.dataset.defaultLabel || btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (data) { return Promise.reject(data); });
        return r.json();
      })
      .then(function () {
        return refreshCart().then(function () {
          if (btn) {
            btn.textContent = '✓  Added to Bag';
            btn.style.background = '#3C7A50';
            setTimeout(function () {
              btn.textContent = defaultLabel || 'Add to Cart';
              btn.style.background = '';
              btn.disabled = false;
            }, 2000);
          }
          showToast('Added to bag');
          setTimeout(openCart, 320);
        });
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = defaultLabel || 'Add to Cart'; }
        var msg = (err && err.description) ? err.description : 'Could not add to cart';
        showToast(msg);
      });
  }

  /* ── Product page: variant picker ── */
  function initProductForm() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var atc          = form.querySelector('.atc');
    var priceEl      = document.getElementById('p-price');
    var jsonEl       = document.getElementById('product-variants-json');

    if (atc) atc.dataset.defaultLabel = atc.textContent.trim();

    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}

    var selected = {};

    /* Init from current variant or first available */
    var current = null;
    if (variantInput && variantInput.value) {
      current = variants.find(function (v) { return String(v.id) === String(variantInput.value); });
    }
    if (!current) current = variants.find(function (v) { return v.available; }) || variants[0];
    if (current) {
      (current.options || []).forEach(function (opt, i) {
        selected['option' + (i + 1)] = opt;
      });
      applyVariant(current);
    }

    /* Pre-load all variant images so swap is instant */
    var preloadedImgs = {};
    variants.forEach(function(v){
      if (v.featured_image && v.featured_image.src && !preloadedImgs[v.featured_image.src]) {
        var pre = new Image();
        pre.src = v.featured_image.src;
        preloadedImgs[v.featured_image.src] = true;
      }
    });

    function applyVariant(v) {
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (priceEl) {
        var sale = document.getElementById('p-price-sale');
        var compare = document.getElementById('p-price-compare');
        if (sale) sale.textContent = formatMoney(v.price); else priceEl.textContent = formatMoney(v.price);
        if (compare) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compare.textContent = formatMoney(v.compare_at_price);
            compare.style.display = '';
          } else {
            compare.style.display = 'none';
          }
        }
      }
      if (atc) {
        /* Trust Trendsi/Shopify to handle real stock at checkout.
           Don't gate ATC on `v.available` — Trendsi inventory sync is unreliable.
           If truly out of stock, Shopify will reject at /cart/add. */
        atc.disabled = false;
        atc.textContent = atc.dataset.defaultLabel || 'Add to Cart';
      }
      if (v.featured_image && v.featured_image.src) {
        var main = document.getElementById('gal-main');
        if (main && main.src !== v.featured_image.src) {
          /* Instant swap - image already preloaded */
          main.src = v.featured_image.src;
        }
      }
    }

    /* Update size availability based on currently selected color.
       NOTE: We only mark size as OUT if there's no variant matching, NOT based on inventory.
       This is because Trendsi inventory sync can be unreliable — let Shopify handle real
       availability at add-to-cart time. */
    function updateSizeAvailability() {
      var sizeButtons = form.querySelectorAll('.sz[data-option-index]');
      if (!sizeButtons.length) return;
      sizeButtons.forEach(function(btn){
        var idx = btn.dataset.optionIndex;
        var sizeVal = btn.dataset.value;
        /* Check if ANY variant exists matching all OTHER selected options + this size.
           Don't check inventory (v.available) — Trendsi may not sync that reliably. */
        var exists = variants.some(function(v){
          if (v[idx] !== sizeVal) return false;
          var ok = true;
          Object.keys(selected).forEach(function(k){
            if (k === idx) return;
            if (selected[k] && v[k] !== selected[k]) ok = false;
          });
          return ok;
        });
        if (exists) {
          btn.classList.remove('out');
          btn.removeAttribute('aria-disabled');
        } else {
          btn.classList.add('out');
          btn.setAttribute('aria-disabled', 'true');
        }
      });
    }

    function resolve() {
      var match = variants.find(function (v) {
        var ok = true;
        Object.keys(selected).forEach(function (k) {
          if (v[k] !== selected[k]) ok = false;
        });
        return ok;
      });
      applyVariant(match);
      updateSizeAvailability();
    }

    /* Run on init */
    updateSizeAvailability();

    /* Color swatches */
    form.querySelectorAll('.col-opt[data-option-index]').forEach(function (el) {
      el.addEventListener('click', function () {
        var idx = el.dataset.optionIndex;
        var val = el.dataset.value;
        selected[idx] = val;
        var group = el.parentElement;
        group.querySelectorAll('.col-opt').forEach(function (s) { s.classList.remove('on'); });
        el.classList.add('on');
        var lbl = document.getElementById('sel-color');
        if (lbl) lbl.textContent = val;
        resolve();
      });
    });

    /* Size buttons */
    form.querySelectorAll('.sz[data-option-index]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        if (el.classList.contains('out')) return;
        var idx = el.dataset.optionIndex;
        var val = el.dataset.value;
        selected[idx] = val;
        var group = el.parentElement;
        group.querySelectorAll('.sz').forEach(function (s) { s.classList.remove('on'); });
        el.classList.add('on');
        resolve();
      });
    });

    /* Form submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || !variantInput.value) {
        showToast('Please select options');
        return;
      }
      addItem(parseInt(variantInput.value, 10), 1, atc);
    });
  }

  /* ── Product page: gallery thumbs + ZOOM + LIGHTBOX ── */
  function initGallery() {
    var main = document.getElementById('gal-main');
    if (!main) return;

    var thumbs = document.querySelectorAll('.thumb[data-src]');
    var allImages = [];
    thumbs.forEach(function(t) { allImages.push({ src: t.dataset.src, hires: t.dataset.hires || t.dataset.src }); });
    if (allImages.length === 0 && main.src) allImages.push({ src: main.src, hires: main.dataset.hires || main.src });

    /* Preload all gallery images for instant swap */
    allImages.forEach(function(im) { var pre = new Image(); pre.src = im.src; });

    /* Thumb click → swap main */
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        main.src = t.dataset.src;
        main.dataset.hires = t.dataset.hires || t.dataset.src;
      });
    });

    /* Hover zoom (lens-style) */
    var container = document.getElementById('gal-zoom-container');
    var lens = document.getElementById('zoom-lens');
    if (container && lens) {
      var zoomActive = false;
      var preloadedHires = false;

      function preloadHires() {
        if (preloadedHires) return;
        preloadedHires = true;
        var hi = new Image();
        hi.src = main.dataset.hires || main.src;
      }

      container.addEventListener('mouseenter', function() {
        if (window.innerWidth < 980) return;
        preloadHires();
        zoomActive = true;
        lens.style.opacity = '1';
        lens.style.backgroundImage = "url('" + (main.dataset.hires || main.src) + "')";
      });
      container.addEventListener('mouseleave', function() {
        zoomActive = false;
        lens.style.opacity = '0';
      });
      container.addEventListener('mousemove', function(e) {
        if (!zoomActive) return;
        var rect = container.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        lens.style.backgroundPosition = x + '% ' + y + '%';
      });
    }

    /* Lightbox */
    var lb = document.getElementById('lz-lightbox');
    var lbImg = document.getElementById('lz-lb-img');
    var lbCount = document.getElementById('lz-lb-count');
    var lbClose = document.getElementById('lz-lb-close');
    var lbPrev = document.getElementById('lz-lb-prev');
    var lbNext = document.getElementById('lz-lb-next');
    var lbExpand = document.getElementById('zoom-expand');
    var currentIdx = 0;

    function openLB(idx) {
      if (!lb || !allImages.length) return;
      currentIdx = idx;
      lbImg.src = allImages[currentIdx].hires;
      if (lbCount) lbCount.textContent = (currentIdx + 1) + ' / ' + allImages.length;
      lb.classList.add('on');
      document.body.style.overflow = 'hidden';
    }
    function closeLB() {
      if (!lb) return;
      lb.classList.remove('on');
      document.body.style.overflow = '';
    }
    function nextLB() {
      currentIdx = (currentIdx + 1) % allImages.length;
      lbImg.src = allImages[currentIdx].hires;
      if (lbCount) lbCount.textContent = (currentIdx + 1) + ' / ' + allImages.length;
    }
    function prevLB() {
      currentIdx = (currentIdx - 1 + allImages.length) % allImages.length;
      lbImg.src = allImages[currentIdx].hires;
      if (lbCount) lbCount.textContent = (currentIdx + 1) + ' / ' + allImages.length;
    }

    if (lbExpand) lbExpand.addEventListener('click', function() {
      var idx = 0;
      for (var i = 0; i < allImages.length; i++) {
        if (allImages[i].src === main.src) { idx = i; break; }
      }
      openLB(idx);
    });
    if (lbClose) lbClose.addEventListener('click', closeLB);
    if (lbNext) lbNext.addEventListener('click', nextLB);
    if (lbPrev) lbPrev.addEventListener('click', prevLB);
    if (lb) lb.addEventListener('click', function(e) { if (e.target === lb) closeLB(); });
    document.addEventListener('keydown', function(e) {
      if (!lb || !lb.classList.contains('on')) return;
      if (e.key === 'Escape') closeLB();
      if (e.key === 'ArrowRight') nextLB();
      if (e.key === 'ArrowLeft') prevLB();
    });

    /* Click main image opens lightbox on mobile */
    main.addEventListener('click', function() {
      if (window.innerWidth < 980) {
        var idx = 0;
        for (var i = 0; i < allImages.length; i++) {
          if (allImages[i].src === main.src) { idx = i; break; }
        }
        openLB(idx);
      }
    });
  }

  /* ── Accordions ── */
  function initAccord() {
    document.querySelectorAll('.acc-hd').forEach(function (h) {
      h.addEventListener('click', function () {
        var item = h.closest('.acc-item');
        if (item) item.classList.toggle('open');
      });
    });
  }

  /* ── Product card swatch hover (decorative) ── */
  function initSwatches() {
    document.querySelectorAll('.swatches').forEach(function (group) {
      group.querySelectorAll('.sw').forEach(function (s) {
        s.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          group.querySelectorAll('.sw').forEach(function (x) { x.classList.remove('on'); });
          s.classList.add('on');
        });
      });
    });
  }

  /* ── Newsletter subscribe (Shopify customer form posts directly) ── */

  /* ── Esc to close ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSG(); closeCart(); closeMenu(); }
  });

  /* ── Boot ── */
  function boot() {
    initProductForm();
    initGallery();
    initAccord();
    initSwatches();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ── Expose for inline onclick handlers ── */
  window.LzCart = { open: openCart, close: closeCart, refresh: refreshCart, addItem: addItem };
  window.LzMenu = { open: openMenu, close: closeMenu };
  window.LzSG   = { open: openSG, close: closeSG };
  window.LzToast = { show: showToast };
  window.showToast = showToast;
  /* Backwards compat for inline handlers from older sections */
  window.openCart = openCart; window.closeCart = closeCart;
  window.openMenu = openMenu; window.closeMenu = closeMenu;
  window.openSG = openSG;     window.closeSG = closeSG;
})();
